export const featuredPortfolio = [
    {
      id: 1,
      title: "Book Store E-commerce Project",
      img:
        "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689508/online-library-isometric-design_98292-34_fslio0.jpg",
      },
    {
      id: 2,
      title: "Human Resource Management System",
      img:
        "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689530/customer-filling-up-survey-form_74855-4398_rlqsnj.jpg",
        
    },
    {
      id: 3,
      title: "Coffee Shop Verification System",
      img:
        "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689579/people-sitting-cafe-flat-design_23-2148234523_twa3sw.jpg",
    },
    {
      id: 4,
      title: "Game Sale Simulation",
      img:
        "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689616/augmented-reality-concept_52683-52516_j0xwqk.jpg",
    },

  ];
  
 export const webPortfolio = [
   {
     id: 1,
     title: "Car Rental Project",
     img: "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689653/buying-renting-new-used-speedy-sports-car_3446-651_ygn9r7.jpg",
   },
   {
     id: 2,
     title: "Blog Project",
     img: "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689680/blog-post-concept-illustration_114360-2162_ns85yb.jpg",
   },
   {
     id: 3,
     title: "Game Cafe automation",
     img: "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689713/illustration-game-shop_53876-35070_r097dy.jpg",
   },
   {
     id: 4,
     title: "Ticket Sales Transactions",
     img: "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689744/sale-tickets-vector-collection-coupon-buy-tag-price-label-paper-promotion-discount-illustration_1284-42780_bnoqke.jpg",
   },
 ];
 
 export const mobilePortfolio = [
   {
     id: 1,
     title: "Coronovirus Map - Python",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689773/coronavirus-map-with-main-countries-infected_23-2148485715_exd8yo.jpg",
   },
   {
     id: 2,
     title: "Data Scraping - Selenium",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689812/data-report-illustration-concept_114360-883_ir2hks.jpg",
   },
   {
     id: 3,
     title: "Relational Database Design",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689843/hand-drawn-flat-design-sql-illustration_23-2149243381_bgsllj.jpg",
   },
   {
     id: 4,
     title: "TypeScript-Angular Product Desgin",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689877/pr-managers-internet-marketers-coworking_335657-3064_b4p6hb.jpg",
   },
 ];
 
 export const designPortfolio = [
   {
     id: 1,
     title: "Movie API",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689906/colorful-cinema-elements-set_1284-37279_pyygqi.jpg",
   },
   {
     id: 2,
     title: "Live Chat APP - MERN Stack",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689932/social-network-members-hands-holding-mobile-live-chat-messaging-flat-colorful-schema-with-speech-bubbles_1284-62368_sqy4rg.jpg",
   },
   {
     id: 3,
     title: "Translation app Api",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689961/translation-dictionary-flat-icons_1284-13181_nvz1iw.jpg",
   },
   {
     id: 4,
     title: "ExpressJs Restful Api",
     img:
       "https://res.cloudinary.com/mycloudimageyea/image/upload/v1642689989/teem-discussing-project-kanban-board_1262-19963_cokm5k.jpg",
   },
 ];
 
 export const contentPortfolio = [
   {
     id: 1,
     title: "Content Clean Code",
     img:
       "https://miro.medium.com/max/1400/1*CP07jhVgupDXZ37Z9bS1eA.jpeg",
      link:"https://y-enesaras.medium.com/clean-code-6b25e4a364df"
   },
   {
     id: 2,
     title: "Content N-Layered Architecture",
     img:
       "https://miro.medium.com/max/1400/1*fhoNDqvf7N4TsIemhMPJ2A.png",
     link:"https://y-enesaras.medium.com/katmanl%C4%B1-mimari-9a50858b073f"
   },
   
 ];
  